// A '.tsx' file enables JSX support in the TypeScript compiler, 
// for more information see the following page on the TypeScript wiki:
// https://github.com/Microsoft/TypeScript/wiki/JSX

import React from 'react';
import InovxLoader from '@shared/global/InovxLoader';
interface ContainerProps extends ReactProps {
    title: string;
    onClick?: any;
}

const FilterContainer = (props: ContainerProps) => (
    <div className="filter-container">
        <div>
            <span className="title">{props.title}</span>
            {props.onClick
                ? <a className="button" key={'cancelButtonKey' + Math.floor(Math.random() * 1000).toString() } onClick={() => props.onClick()}> {InovxLoader.t('common:clear')} </a>
                : false
            }
        </div>
        <div>
            {props.children}
        </div>
    </div>
);
export default FilterContainer;
